import AbstractRequestTask from '../../AbstractRequestTask';
import Launcher from '../../../apa/Launcher';
import { ENABLE_MODAL_RETRIES } from '../../../RequestManagerConstants';
import Utils from 'src/utils/Utils';

class RegisterV1Task extends AbstractRequestTask {
    constructor(body = {}) {
        super();
        this.body = body;
        this.statusCode403As200 = true;
    }

    getMethod() {
        return 'POST';
    }

    getUrl() {
        const http = "https://";
        const url = Launcher.get("akamai_mfwk"); 
        return `${http}${url}/services/user/v1/register?${this.getQueryStringParams()}`;
    }

    getParams() {
        delete this.body.includpaywayprofile;
        return Utils.encodeParams(this.body);
    }

    getHeaders() {
        return {
            'Content-Type': 'application/x-www-form-urlencoded',
        };
    }

    getQueryStringParams() {
        const params = super.getParams();
        delete params.HKS;
        delete params.api_version;
        delete params.user_token;
        delete params.username;
        return Utils.buildQueryParams(params);
    }

    getShowErrorModal(){
        return ENABLE_MODAL_RETRIES;
    }

    getStatusCode403As200(){
    return this.statusCode403As200;
    }

    isValid(response) {
        if (response && response.errors){
            return false;
        }{
            return true;
        }
    }
}

export default RegisterV1Task;


// WEBPACK FOOTER //
// ./src/requests/tasks/user/v1/RegisterOttV1Task.js